import React,{Component} from 'react';
import {Toast} from '@react/react-spectrum/Toast';
import i18n from "../../i18n";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {enableSuccessToastInfo,enableRejectToastInfo,showApiErrorMessage,enableAgreementSuccessToastInfo,enableAgreementRejectToastInfo} from "../../actions/ToastActions";

export class ToastInfo extends Component{

    constructor(props){
        super(props);
        this.handleOnClose = this.handleOnClose.bind(this);
    }

    handleOnClose(){
        this.props.setSuccessToastFlag(false);
        this.props.setRejectToastFlag(false);
        this.props.showApiErrorMessage(false);
    }

    render(){
        let toast = '';
        if(this.props.showSuccessMsg){
            toast =  <Toast closable onClose={this.handleOnClose} variant="success">{i18n.t('successMessage')}</Toast>;
        }
        if(this.props.showRejectToast){
            toast =  <Toast closable onClose={this.handleOnClose} variant="success">{i18n.t('rejectSuccessMessage')}</Toast>;
        }
        if(this.props.showApiErrorToast){
            toast = <Toast closable onClose={this.handleOnClose} variant="error">{i18n.t('serverErrorMessage')}</Toast>;
        }
        if(this.props.showAgreementSuccessToast){
            toast = <Toast closable onClose={this.handleOnClose} variant="success">{i18n.t('agreementSuccessMessage')}</Toast>;
        }
        if(this.props.showAgreementRejectToast){
            toast = <Toast closable onClose={this.handleOnClose} variant="success">{i18n.t('agreementRejectMessage')}</Toast>;
        }
        return(
            <div style={{margin:'10px 0 0 10px',textAlign:'center'}}>
                {toast}
            </div>
        )
    }
}


const mapStateToProps = (state)=>{
    return{
        showSuccessMsg:state.ToastReducer.showSuccessToast,
        showRejectToast:state.ToastReducer.showRejectToast,
        showApiErrorToast: state.ToastReducer.showApiErrorToast,
        showAgreementSuccessToast: state.ToastReducer.showAgreementSuccessToast,
        showAgreementRejectToast: state.ToastReducer.showAgreementRejectToast
    }
};


const mapDispatchToProps = (dispatch)=>{
    return{
        setAgreementSuccessToastFlag:(flag)=>{dispatch(enableAgreementSuccessToastInfo(flag))},
        setAgreementRejectToastFlag:(flag)=>{dispatch(enableAgreementRejectToastInfo(flag))},
        setSuccessToastFlag:(flag)=>{dispatch(enableSuccessToastInfo(flag))},
        setRejectToastFlag:(flag)=>{dispatch(enableRejectToastInfo(flag))},
        showApiErrorMessage:(flag)=>{dispatch(showApiErrorMessage(flag))}
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(ToastInfo));

